import { Clipper } from "../../../clipper";
import { checkForProblems } from "./algorithm";
import { deserializeInputs } from "./serde";
export async function runCopperOverlapDrc(serializedInputs) {
    // Initialize Clipper library - TODO: consider abstracting this so that clipper is
    // always initialized, and available to, DRC run on a worker
    await Clipper.initialize();
    const inputs = await deserializeInputs(serializedInputs);
    const result = checkForProblems(inputs);
    return result;
}
//# sourceMappingURL=copperOverlapDetection.js.map